import React, { useEffect, useState } from 'react';
import { Flex, Spinner, Text } from '@chakra-ui/react';

const ROTATION_MS = 6000;

const SHIM_MESSAGES = [
  'Translating…',
  'This may take a moment…',
  'Still working on your translations…',
  'Almost there…',
  'Finishing up…',
] as const;

interface AutoTranslateBodyShimProps {
  isActive: boolean;
}

/**
 * Blocks interaction with modal body content while auto-translate is in flight.
 */
export function AutoTranslateBodyShim({ isActive }: AutoTranslateBodyShimProps) {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (!isActive) {
      return () => {};
    }

    setMessageIndex(0);

    const id = window.setInterval(() => {
      setMessageIndex((i) => (i + 1) % SHIM_MESSAGES.length);
    }, ROTATION_MS);

    return () => clearInterval(id);
  }, [isActive]);

  if (!isActive) {
    return null;
  }

  const message = SHIM_MESSAGES[messageIndex];

  return (
    <Flex
      position="absolute"
      inset={0}
      zIndex={1}
      align="center"
      justify="center"
      direction="column"
      gap={3}
      bg="whiteAlpha.800"
      pointerEvents="auto"
    >
      <Spinner size="xl" color="blue.500" thickness="4px" aria-hidden />
      <Text
        role="status"
        aria-live="polite"
        color="gray.700"
        fontWeight="medium"
        textAlign="center"
        px={4}
      >
        {message}
      </Text>
    </Flex>
  );
}
